/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![DenyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACC0lEQVR4nMVVS0scQRCeS9CoBBUEiV6T/AgTPAmDs11VCr1VamDcHPYniOhv8nH0CeJNxEs8xHhMcjdqzkmonu5dN7OP2VmCBQMzQ/VXr6++jqLnNGvtJJB8ApR9Q3IDxL/08e97ANVakqxOlAF+CcTbQHwPJH+6PQblp0He0jOFwJeW1mYB5aoBQHxgkNeJ+G29Xn9hrR1LllfeGJIUkE+B5Lf3u0wSO9MbnOSHA0f+UqGV970SQuQPgHybVcPfOwZxbQmZI58hpuNFKo6tnQKU6ycVX86n6XDOMet5lnkpcJTrUAkQb/6b/WQYaJG2tAPXbz0bBt/CLkfFzPEwKgkeBaxs8DqP9WYAlP2sf5IOAv40WUO8GwUzKF/dAbDvogHA1ZTOPtmbKJghedCfbaffB7jawsLHUR/gofHToDy6AVcqI+0OxdZOGeLPgWWL1k5HHUwxPJPucy3SDS2bedcWOeFqM+R+wdWUPd5/pxkAqjVf/ukg4GpAcpJLVhdNl0OFS7WlLHglLBrxXU4NVHJ9FbdlwON47VVT9GQj56AUVaFqaH2f4Ibk3G/wRUe6q9Sq5AYWmOXqXJG2BBYakm8A8rrrARekpRI+CheOclxl3VERqjVDcty4cJAveoIH0xJVcv3gu1+ZxHfa8ziOhwqBt1azOpHxmvd0g3Xj3dbrO/GuUrHo3fHf7C+lRZZ2EKNO3AAAAABJRU5ErkJggg==)
 */
export const DenyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-2 0a9 9 0 0 1-14.62 7.03L19.03 6.38A8.96 8.96 0 0 1 21 12ZM4.97 17.62 17.62 4.97A9 9 0 0 0 4.97 17.62Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
